import type { InputHTMLAttributes } from 'react';

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  isChecked: boolean;
  outerSize?: number;
  innerSize?: number;
}

function Radio({ isChecked, onChange, className, outerSize = 20, innerSize = 10, ...props }: RadioProps) {
  return (
    <label className={`inline-flex cursor-pointer items-center ${className || ''}`}>
      <input type="radio" className="peer hidden" checked={isChecked} onChange={onChange} {...props} />
      <div className="grid place-items-center rounded-full bg-[#52536C] transition-colors peer-checked:bg-[#52536C]" style={{ width: `${outerSize}px`, height: `${outerSize}px` }}>
        <div className={`rounded-full bg-white ${isChecked ? 'block' : 'hidden'}`} style={{ width: `${innerSize}px`, height: `${innerSize}px` }}></div>
      </div>
    </label>
  );
}

export default Radio;
